declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';

import { SpinnerService } from '../../services/spinner.service';
import { AppData } from '../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HCPService } from '../../services/hcp.service';
import * as alertFunctions from '../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../shared/services/toastr.service';
import { ActorService } from '../../services/actor.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { FDService } from '../../services/fd.service';
import { ConsultantMapPipe } from '../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgxSpinnerService } from 'ngx-spinner';
//import { getUTCDate } from 'NgbDateParserFormatter';
@Component({
  selector: 'ngbresults',
  templateUrl: './results.modal.html',
  styleUrls: ['./results.modal.scss']
})

export class NgbResult implements OnInit {

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe, private parserFormatter: NgbDateParserFormatter,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService, private modalService: NgbModal,
    private tosterservice: NGXToastrService, private spinner: NgxSpinnerService) { }



  ngOnInit() {


  }




}
